// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__32LgN","itemTitle":"ClientEmergencyInfo_itemTitle__fibG9","itemText":"ClientEmergencyInfo_itemText__2BNfv"};